<template>
  <div class="content-tab igmp-snooping">
    <div class="content-body">
      <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="describe">
          {{$t('igmp.describe')}}
        </div>
        <div class="formRow header">
          <span class="title">{{$t('igmp.igmpsnooping')}}</span>
          <toggle :on="isSnoopEnable" @click.native="onSwitchBtn('Snoop')"></toggle>
        </div>
        <div class="formRow">
          <span class="title">{{$t('igmp.blockFlooding')}}</span>
          <toggle :disabled="!isSnoopEnable" :on="isBlockEnable" @click.native="onSwitchBtn('Block')"></toggle>
          <div class="icon-info info-color ft-14 flooding" v-on:click="onInfoClick"/>
        </div>
        <div class="formRow" v-if ="!systemHostInfo.Product.includes('M5216')">
          <span class="title">{{$t('igmp.igmpsnoopQuerier')}}</span>
          <toggle :disabled="!isSnoopEnable" :on="isQuerierEnable" @click.native="onSwitchBtn('Querier')"></toggle>
        </div>
        <div class="formRow">
          <span class="title">{{$t('igmp.portSetting')}}</span>
        </div>
        <table class="group-table">
          <tr class="table-header">
            <td class="title" style="width:11%;">
              <span class="subtitle1" :id="$t('config')" :title="this.$isOverflow($t('config'))">{{$t('config')}}</span>
              <span class="slash"></span>
              <span class="subtitle">{{$t('acl.port')}}</span>
            </td>
            <td class="all" style="width:5%;">{{$t('all')}}</td>
            <td class="item" :style="{ width: (48/ portNumber)+'%' }" v-for="num in portNumber" :key="num">{{num}}</td>
            <td class="item" :style="{ width: (36/ lagGroupMap.size)+'%' }" v-for="num in lagGroupMap.size" :key="num + lagStartNum">{{$t('lag.groupName') + ' ' + num}}</td>
          </tr>
          <tr class="table-item">
            <td class="title" style="width:11%;">{{$t('igmp.routerPort')}}</td>
            <td class="all" style="width:5%;">
            </td>
            <td class="item" :style="{ width: (48/ portNumber)+'%' }" v-for="num in portNumber" :key="num" :title="getTips(num)">
              <div class="formlabel fontB subitem">
                  <radio class="router" :disabled="!isSnoopEnable || getDisabled(num)" :checked="isItemChecked('router', num)" @click.native="onSelection('router', num)" :id="getID('router', num)"></radio>
              </div>
            </td>
            <td class="item" :style="{ width: (36/ lagGroupMap.size)+'%' }" v-for="num in lagGroupMap.size" :key="num+lagStartNum">
              <div class="formlabel fontB subitem">
                  <radio class="router" :disabled="!isSnoopEnable" :checked="isItemChecked('router', num+lagStartNum)" @click.native="onSelection('router', num+lagStartNum)" :id="getID('router', num+lagStartNum)"></radio>
              </div>
            </td>
          </tr>
          <tr class="table-item">
            <td class="title" style="width:11%;">{{$t('igmp.fastLeave')}}</td>
            <td class="all" style="width:5%;">
              <div class="formlabel fontB subitem" v-on:click="onAllSelection('fast')">
                <checkbox class="q-checkbox-label" :disabled="!isSnoopEnable" :checked="isFastAll" :id="'all'" />
              </div>
            </td>
            <td class="item" :style="{ width: (48 / portNumber)+'%' }" v-for="num in portNumber" :key="num" :title="getTips(num)">
              <div class="formlabel fontB subitem" v-on:click="onSelection('fast', num)">
                <checkbox class="q-checkbox-label" :disabled="!isSnoopEnable || getDisabled(num)" :checked="isItemChecked('fast', num)" :id="'checkbox-' + num" />
              </div>
            </td>
            <td class="item" :style="{ width: (36/ lagGroupMap.size)+'%' }" v-for="num in lagGroupMap.size" :key="num+lagStartNum">
              <checkbox class="q-checkbox-label" :disabled="true" :title="$t('igmp.lagGroupTip')" :id="'checkbox-' + (num + lagStartNum)" />
            </td>
          </tr>
        </table>
        <div class="error" v-if="vlanerror">{{$t('igmp.supportVlan1')}}</div>
        <!-- <div class="formRow header">
          <span class="title">{{$t('igmp.snoopQuerier')}}</span>
        </div>
        <div class="formRow">
          <span class="title">{{$t('igmp.snoopTarget')}}</span>
          <span class="item dynamic-color">{{vlanid}}</span>
        </div>
        <div class="formRow no-s" v-if="vlanid !== 0">
          <table class="querier-table">
            <tr class="table-header">
              <td class="item" style="width: 160px;">{{$t('igmp.querierAddress')}}
                <div class="icon-info info-color ft-14 address" @click="onInfoClick"/>
              </td>
              <td class="item" style="width: 160px;">{{$t('igmp.querierElection')}}
                <div class="icon-info info-color ft-14 election" @click="onInfoClick"/>
              </td>
            </tr>
            <tr class="table-item">
              <td class="item" style="width: 160px;">{{address}}</td>
              <td class="item" style="width: 160px;">
                <toggle :on="isQuerierEnable" @click.native="onSwitchBtn('Querier')"></toggle>
              </td>
            </tr>
          </table>
        </div>
        <div class="formRow empty" v-if="vlanid === 0">
          <nodata/>
          <div>{{$t('empty')}}</div>
        </div> -->
      </scrollbar>
      <div class="content-body-footer">
        <button class="q-button blue-btn-full right" :title="$t('save')" v-on:click="onSaveClick()" :disabled="!isButtonEnable">{{$t('save')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import toggle from './module/Toggle'
import checkbox from './module/Checkbox'
import Radio from './module/Radio'
import nodata from '../assets/svg/no_data.svg'
export default {
  name: 'lgmpSnooping',
  components: {
    toggle,
    Radio,
    checkbox,
    nodata
  },
  data () {
    return {
      isShowLoading: false,
      isSnoopEnable: false,
      isBlockEnable: false,
      isButtonEnable: false,
      snoopObj: null,
      querierObj: null,
      originalData: {
        snoopObj: null,
        querierObj: null,
        fastList: null
      },
      fastList: [],
      isFastAll: false,
      isQuerierEnable: false,
      address: '0.0.0.0',
      vlanid: 0,
      countRefresh: 0,
      selRouter: null,
      checkRefresh: {
        'IGMPSnooping': false,
        'IGMPVlanConfig': false,
        'setIGMPPort': false,
        'addIGMPPort': false,
        'delIGMPPort': false
      },
      vlanerror: false,
      vlanPortList: [],
      dataInterval: null
    }
  },
  created () {
    this.getVlanById(1)
      .then((result) => {
        if (result.data && result.data.error_code === 200) {
          result.data.result[0].val.forEach(element => {
            this.vlanPortList.push(element.Port)
          })
        }
      })
    let me = this
    window.addEventListener('resize', this.myEventHandler)
    setTimeout(() => {
      me.$forceUpdate()
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (this.isDataChanged) {
      next(false)
    } else {
      next()
    }
  },
  beforeDestroy () {
    clearInterval(this.dataInterval)
    this.dataInterval = null
  },
  watch: {
    isButtonEnable: function (value) {
      if (!value) {
        this.$store.commit('updateDataChanged', false)
      } else {
        this.$store.commit('updateDataChanged', true)
      }
    },
    currentUser: {
      handler (value) {
        if (value && value.auth !== undefined) {
          this.firstGetData()
        }
      },
      immediate: true,
      deep: true
    },
    lang: {
      handler (value) {
        let me = this
        setTimeout(() => {
          me.$forceUpdate()
        }, 500)
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['getIGMPSnooping', 'setIGMPSnooping', 'getIGMPPort', 'setIGMPPort', 'addIGMPPort', 'delIGMPPort', 'addIGMPVlanConfig', 'setIGMPVlanConfig', 'getIGMPVlanConfig', 'getVlanById']),
    getData: function () {
      if (this.firstGetData()) return
      let me = this
      let getDataTimeout = 50000
      let count = Math.floor(getDataTimeout / this.intervalTime)
      this.dataInterval = setInterval(() => {
        count--
        if (this.firstGetData()) {
          clearInterval(me.dataInterval)
          me.dataInterval = null
        } else {
          if (count > 0) {
            me.$store.commit('setErrorNum', false)
          }
        }
      }, this.intervalTime)
    },
    async firstGetData () {
      let me = this
      let result = false
      me.isShowLoading = true
      await this.axios.all([this.getIGMPSnooping(), this.getIGMPPort(), this.getIGMPVlanConfig()])
        .then(this.axios.spread(function (snoopingConf, portConf, vlanConf) {
          if (snoopingConf.error_code === 200 && snoopingConf.result) {
            me.snoopObj = snoopingConf.result
            me.isSnoopEnable = me.snoopObj.AdminState
            me.isBlockEnable = !me.snoopObj.UnregisteredFlooding
            me.originalData.snoopObj = JSON.parse(JSON.stringify(me.snoopObj))
          }
          if (portConf.error_code === 200) {
            let result = (portConf.result) ? portConf.result : null
            let tempList = []
            if (result) {
              result.forEach(element => {
                if (element.val.LeaveMode === 2 && !me.portMap.get(parseInt(element.key))) {
                  tempList.push(element.key)
                }
              })
            }
            me.fastList = tempList
            me.originalData.fastList = JSON.parse(JSON.stringify(me.fastList))
          }
          if (vlanConf && vlanConf.result) {
            me.querierObj = vlanConf.result[0]
            me.originalData.querierObj = JSON.parse(JSON.stringify(me.querierObj))
            me.isQuerierEnable = me.querierObj.val.QuerierElection
            // me.address = me.querierObj.val.QuerierAddress
            me.selRouter = (me.querierObj.val.AsRouterPort) ? me.querierObj.val.AsRouterPort[0] : null
          } else {
            // add vlan1 config
            let tempquerier = {
              'key': '1',
              'val': {
                'AdminState': me.isSnoopEnable,
                'QuerierElection': me.isQuerierEnable,
                'QuerierAddress': me.address,
                'AsRouterPort': []
              }
            }
            me.addIGMPVlanConfig(tempquerier)
              .then((res) => {
                me.querierObj = tempquerier
                me.originalData.querierObj = JSON.parse(JSON.stringify(me.querierObj))
                me.$forceUpdate()
              })
          }
          me.isShowLoading = false
          // me.$store.commit('updateFullLoadingStatus', false)
          me.vlanid = 1
          result = true
        })).catch((err) => {
          me.$log.error(err)
        })
      return result
    },
    getQuerierStatus: function (item) {
      if (!item.QuerierStatus) {
        if (item.QuerierElection) {
          this.isQuerierEnable = true
        } else {
          this.isQuerierEnable = false
        }
      } else if (item.QuerierStatus === 'disabled') {
        this.isQuerierEnable = false
      } else {
        this.isQuerierEnable = true
      }
    },
    onSwitchBtn: function (type) {
      if (type === 'Snoop') {
        this.isSnoopEnable = !this.isSnoopEnable
      } else if (type === 'Block') {
        if (this.isSnoopEnable) {
          this.isBlockEnable = !this.isBlockEnable
        }
      } else {
        this.isQuerierEnable = !this.isQuerierEnable
      }
      this.isButtonEnable = true
    },
    onAllSelection: function (type) {
      if (this.isSnoopEnable) {
        this.isFastAll = !this.isFastAll
        this.fastList = []
        if (this.isFastAll) {
          this.selRouter = null
          for (let index = 0; index < this.portNumber; index++) {
            if (!this.getDisabled(index + 1)) {
              this.fastList.push('' + (index + 1))
            }
          }
        }
        this.isButtonEnable = true
      }
    },
    onSelection: function (type, item) {
      let index = this.fastList.indexOf('' + item)
      if (this.isSnoopEnable) {
        if (type === 'router') {
          this.selRouter === '' + item ? this.selRouter = null : this.selRouter = '' + item
          if (index > -1) {
            this.fastList.splice(index, 1)
          }
        } else {
          if (!this.getDisabled(item)) {
            if (this.selRouter === '' + item) {
              this.selRouter = null
            }
            if (index > -1) {
              this.fastList.splice(index, 1)
            } else {
              this.fastList.push('' + item)
            }
          }
        }
        if (this.fastList.length === (this.portNumber - this.portMap.size)) {
          this.isFastAll = true
        } else {
          this.isFastAll = false
        }
        this.isButtonEnable = true
      }
    },
    isItemChecked: function (type, item) {
      let index = this.fastList.indexOf('' + item)
      if (item !== 'all') {
        if (type === 'router') {
          return this.selRouter === '' + item
        } else {
          return (index > -1)
        }
      }
    },
    checkToRefresh: function (type) {
      let canRefresh = true
      this.checkRefresh[type] = true
      for (const key in this.checkRefresh) {
        if (this.checkRefresh.hasOwnProperty(key)) {
          const element = this.checkRefresh[key]
          if (!element) {
            canRefresh = false
          }
        }
      }
      if (canRefresh) {
        this.getData()
        this.isButtonEnable = false
        this.checkRefresh = {
          'IGMPSnooping': false,
          'IGMPVlanConfig': false,
          'setIGMPPort': false,
          'addIGMPPort': false,
          'delIGMPPort': false
        }
      }
    },
    checkRouterFastLeavePort: function () {
      let result = false
      if (this.selRouter) {
        if (!this.vlanPortList.includes('' + this.selRouter)) {
          result = true
        }
      }
      if (this.fastList.length > 0) {
        this.fastList.forEach(item => {
          if (!this.vlanPortList.includes('' + item) && !this.portMap.get(parseInt(item))) {
            result = true
          }
        })
      }
      this.vlanerror = result
      return !this.vlanerror
    },
    onSaveClick: async function () {
      let allPortList = []
      let leaveMode = 3
      for (let i = 1; i <= this.portNumber; i++) {
        let port = {
          'idx': i.toString(),
          'data': {
            'LeaveMode': leaveMode
          }
        }
        allPortList.push(port)
      }
      for (let i = this.lagStartNum + 1; i <= (this.lagStartNum + this.lagGroupMap.size); i++) {
        let port = {
          'idx': i.toString(),
          'data': {
            'LeaveMode': leaveMode
          }
        }
        allPortList.push(port)
      }
      await this.addIGMPPort(JSON.stringify(allPortList))
      let me = this
      let tempsnoop = {
        AdminState: this.isSnoopEnable,
        UnregisteredFlooding: !this.isBlockEnable,
        Querier: this.isQuerierEnable
      }
      let tempquerier = {
        key: this.originalData.querierObj.key,
        val: {
          AdminState: this.isSnoopEnable,
          QuerierElection: this.isQuerierEnable,
          // QuerierAddress: this.originalData.querierObj.val.QuerierAddress,
          QuerierAddress: this.address,
          AsRouterPort: (this.selRouter) ? ['' + this.selRouter] : [],
          BlockRouterPort: (this.selRouter) ? this.getBlockRouter(this.selRouter) : []
        }
      }
      if (this.checkRouterFastLeavePort()) {
        this.isButtonEnable = false
        if (!this.$compareObj(tempsnoop, this.originalData.snoopObj)) {
          await this.setIGMPSnooping(tempsnoop)
            .then((res) => {
              this.checkToRefresh('IGMPSnooping')
            })
        } else {
          this.checkToRefresh('IGMPSnooping')
        }
        let existList = JSON.parse(JSON.stringify(this.originalData.fastList))
        if (!this.$compareObj(me.fastList, this.originalData.fastList)) {
          let fastListCheck = 0
          let delListCheck = 0
          let delArr = []
          let setArr = []
          let addArr = []
          if (me.fastList.length > 0) {
            me.fastList.forEach(item => {
              let port = {
                'idx': item,
                'data': {
                  'LeaveMode': 2
                }
              }
              let exist = (existList) ? existList.indexOf(item) : -1
              if (exist > -1) {
                fastListCheck++
                setArr.push(port)
                existList.splice(exist, 1)
              } else {
                fastListCheck++
                addArr.push(port)
              }
            })
            if (addArr.length > 0) {
              await me.addIGMPPort(JSON.stringify(addArr)).then((res) => {
                if (fastListCheck === me.fastList.length) {
                  me.checkToRefresh('addIGMPPort')
                  me.checkToRefresh('setIGMPPort')
                }
              })
            }
            if (setArr.length > 0) {
              await me.setIGMPPort(JSON.stringify(setArr)).then((res) => {
                if (fastListCheck === me.fastList.length) {
                  me.checkToRefresh('setIGMPPort')
                  me.checkToRefresh('addIGMPPort')
                }
              })
            }
          } else {
            me.checkToRefresh('setIGMPPort')
            me.checkToRefresh('addIGMPPort')
          }
          if (existList && existList.length > 0) {
            existList.forEach(item => {
              delArr.push(item)
              delListCheck++
            })
            await me.delIGMPPort(delArr).then((res) => {
              if (delListCheck === existList.length) {
                me.checkToRefresh('delIGMPPort')
              }
            })
          } else {
            await me.checkToRefresh('delIGMPPort')
          }
        } else {
          if (me.fastList.length > 0) {
            let addArr = []
            me.fastList.forEach(item => {
              let port = {
                'idx': item,
                'data': {
                  'LeaveMode': 2
                }
              }
              addArr.push(port)
            })
            await this.addIGMPPort(JSON.stringify(addArr))
          }
          this.checkToRefresh('setIGMPPort')
          this.checkToRefresh('addIGMPPort')
          this.checkToRefresh('delIGMPPort')
        }
        if (!this.$compareObj(tempquerier, this.originalData.querierObj)) {
          // this.$store.commit('updateFullLoadingStatus', true)
          this.setIGMPVlanConfig(tempquerier)
            .then((res) => {
              this.checkToRefresh('IGMPVlanConfig')
            }).catch((err) => {
              me.$log.error(err)
              this.$store.commit('setErrorNum', false)
              this.checkToRefresh('IGMPVlanConfig')
            })
        } else {
          this.checkToRefresh('IGMPVlanConfig')
        }
      }
    },
    onInfoClick: function (event) {
      let message = []
      this.$store.commit('updateInfoTips', !this.showInfoTips)
      if (this.showInfoTips) {
        var className = event.currentTarget.className
        if (className.indexOf('flooding') > -1) {
          message.push({text: this.$t('igmp.blockFloodingNote')})
        } else if (className.indexOf('address') > -1) {
          message.push({text: this.$t('igmp.addressInfo1')})
          message.push({text: this.$t('igmp.addressInfo2')})
          message.push({text: this.$t('igmp.addressInfo3')})
          message.push({text: this.$t('igmp.addressInfo4')})
        } else if (className.indexOf('election') > -1) {
          message.push({text: this.$t('igmp.electionInfo1')})
          message.push({text: this.$t('igmp.electionInfo2')})
        }
        this.$store.commit('updateInfoData', {
          message: message,
          event: event
        })
      }
    },
    onHelpClick: function () {
      this.$store.commit('updateQuickHelp', !this.showQuickHelp)
    },
    getDisabled: function (port) {
      if (this.portMap.get(port)) {
        return true
      } else {
        return false
      }
    },
    getTips: function (key) {
      let num = Number(key)
      let tips = ''
      if (this.getDisabled(num)) {
        tips = this.$t('lag.alreadyJoin')
      }
      return tips
    },
    getID: function (type, number) {
      return 'radio-' + type + '-' + number
    },
    getBlockRouter (selRouter) {
      let portList = []
      return portList
      // if (this.systemHostInfo.Product.includes('M5216')) return portList
      // for (let i = 1; i <= this.portNumber; i++) if (i.toString() !== selRouter) portList.push(i.toString())
      // for (let i = this.lagStartNum + 1; i <= (this.lagStartNum + this.lagGroupMap.size); i++) if (i.toString() !== selRouter) portList.push(i.toString())
      // return portList
    },
    myEventHandler (e) {
      this.$forceUpdate()
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.lang,
      isDataChanged: state => state.app.isDataChanged,
      showQuickHelp: state => state.app.showQuickHelp,
      showInfoTips: state => state.app.showInfoTips,
      showFullLoading: state => state.module.showFullLoading,
      portNumber: state => state.module.portNum,
      currentUser: state => state.module.currentUser,
      portMap: state => state.module.portMap,
      lagStartNum: state => state.module.lagStartNum,
      lagGroupMap: state => state.module.lagGroupMap,
      intervalTime: state => state.app.intervalTime,
      systemHostInfo: state => state.module.systemHostInfo
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/common.scss';
.igmp-snooping {
  position: relative;
  padding: 10px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  >.content-body {
    .formRow {
      padding-top: 10px;
      >.block-note {
        font-size: 13px;
        color: #5B7C94;
      }
      &.empty {
        text-align: center;
        margin: auto;
        >svg {
          width: 150px;
          height: 150px;
        }
        >div {
          font-family: 'Roboto-M' !important;
          font-size: 16px;
        }
      }
      >.title {
        font-family: 'Roboto-M' !important;
        padding-right: 10px;
      }
    }
    .scrollbar-body {
      height: calc(100% - 50px);
    }
  }
  .group-table {
    width: 100%;
    margin-top: 10px;
    td {
      height: 40px;
    }
    .title {
      height: 100%;
      padding-left: 20px;
      position: relative;
      line-height: 40px;
      font-family: 'Roboto-M' !important;
      .subtitle {
        position: absolute;
        display: inline-block;
        right: 10px;
        top: -8px;
      }
      .subtitle1 {
        position: absolute;
        left: 2px;
        top: 5px;
        z-index: 1;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: 50%;
      }
      .slash {
        position: absolute;
        display: inline-block;
        width: 100%;
        height: 40px;
        top: 0;
        left: 0;
        &:before {
          content: '';
          position:absolute;
          left:0px;
          top:0;
          right:0;
          bottom:0;
          -webkit-clip-path: polygon(0 0, 0 100%, 230% 225%, 0 0);
          clip-path: polygon(0 0, 0 100%, 230% 225%, 0 0);
          background:#fff;
        }
      }
    }
    .all, .item {
      text-align: center;
    }
    .q-checkbox-label {
      display: block;
      margin: auto;
    }
  }
  .querier-table {
    .item {
      padding-left: 20px;
    }
  }
  .querier-table, .group-table {
    >.table-header {
      background-color: #F2F3F8;
      height: 28px;
    }
    >.table-item {
      height: 38px;
      >.all {
        background-color: rgba(0,0,0,0.20);
      }
    }
  }
  .content-body-footer {
    position: absolute;
    top: calc(100% - 50px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/IgmpSnooping.vue